import React from 'react'

import "../header/Header.scss"

const Header = () => {
  return (
    <div className='who-are-you'>
      Who Are You?
    </div>
  )
}

export default Header